







import { Component, Vue } from 'vue-property-decorator';
import TranslationApiAgent from '@/services/translation-api-agent';
import AuthApiAgent from '@/services/auth-api-agent';
import SessionService from '@/services/session-service';

// @ts-ignore
@Component()
export default class AdminRoot extends Vue {
  private logoutStr: string = this.translationApiAgent.get('logout');

  constructor(
    private translationApiAgent = TranslationApiAgent,
    private authApiAgent = AuthApiAgent,
    private sessionService = SessionService) {
    super();
  }

  get isAdmin() {
    return this.authApiAgent.isAdmin;
  }

  private logout() {
    this.sessionService.logout();
    window.location.reload();
  }
}
